import TrendScatterChartsService from "./TrendScatterChartsService";

/**
 * Formata os dados do gráfico de domínio personalizado para utilizar na análise comparativa.
 * @param {object} params - Os parâmetros para formatar os dados de domínio personalizado.
 * @returns {object} Um objeto contendo os dados formatados.
 */
const FormatScatterChartData = (params) =>
{
	const { chartData, dateTimeParams } = params;
	return {
		alarm:     chartData.alarm,
		trip:      chartData.trip,
		trends:    chartData.trends,
		startDate: dateTimeParams.startDate,
		endDate:   dateTimeParams.endDate,
	};
};

/**
 * @summary Cria o state de tendências.
 * @returns State de Tendências.
 */
const FactoryEmptyTrendState = function()
{
	return { comparativePlots: TrendScatterChartsService.FactoryEmptyComparativeScatterChartState() };
};

export default { FactoryEmptyTrendState, FormatScatterChartData };